import { render } from "./NewVendor.vue?vue&type=template&id=44c46599&scoped=true"
import script from "./NewVendor.vue?vue&type=script&lang=js"
export * from "./NewVendor.vue?vue&type=script&lang=js"

import "./NewVendor.vue?vue&type=style&index=0&id=44c46599&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c46599"]])

export default __exports__